
import LayoutContent from '../../components/layouts/content2';
import React, {useState, useEffect} from 'react';
import { getData, getImage } from '../../helpers/indexedDbHelper';
import { useRefresh } from '../../hooks/useRefresh';
import SpecialsScreen from './specials';
import CategoriesScreen from './categories';
import Cocktails from './cocktails';
import EventsScreen from './events';
import ListProducts from './ListProducts';
import ColdDrinks from './colddrinks';
import Alcoholic from './alcoholic';
import BottleScreen from './bottle';
import { useTranslation } from 'react-i18next';

function Index({setShowHappy}) { 

    const { i18n } = useTranslation();
      const langEng = i18n.language === 'en' ?? false;
    
     const {change, getInitData} = useRefresh();

    const [menus, setMenus] = useState([]);
    const [showSpecials, setShowSpecials] = useState(false);
    const [showCategories, setshowCategories] = useState(false);
    const [showCocktails, setShowCocktails] = useState(false);
    const [showEvents, setShowEvents] = useState(false);
    const [hotdrinks, sethotdrinks] = useState(false);
     const [dishs, setdishs] = useState(false);
    const [showListProduct, setShowListProduct] = useState(false);
    const [showColdDrinks, setShowColdDrinks] = useState(false);
    const [showAlcoholic, setShowAlcoholic] = useState(false);
    const [showBottle, setShowBottle] = useState(false);
    const [signatireCocktail, setsignatireCocktail] = useState(false);
    const [clasicCocktail, setclasicCocktail] = useState(false);
    const [sangria, setsangria] = useState(false);

     useEffect(() => {
        getData('menu').then((items) => {
            // Sin menu en disco todavia: no reventar la app entera.
            if (!items?.value?.data) return;
            const data = items.value.data;
            setMenus(data);
        });
    }, [change]);

     useEffect(() => {
            menus.map((item) => {
            if (item.id === 903) {
                setsignatireCocktail(item);
            }
                if (item.id === 904) {
                setclasicCocktail(item);
                }
                if (item.id === 966) {
                setsangria(item);
            }
        });
    }, [menus]);



    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent  goCategories={setshowCategories} showCocktails={ setShowCocktails} showEvents={ setShowEvents} showBack={true} setShowSpecials={setShowSpecials} setShowListProduct={setShowHappy} setShowColdDrinks={setShowColdDrinks}>
                <div style={{padding: '0 20px', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                    <div style={{width: '100%', marginBottom: 2, position: 'relative', marginTop: 230}}>
                        <div onClick={() => {
                            setShowListProduct(true)
                            setdishs(signatireCocktail)
                        }}>
                            <img
                            src={require(langEng ? './assets/coctacil.png': './assets/coces.png')}
                            onContextMenu={(e) => e.preventDefault()}
                            style={{
                                width: 360,
                                height: 120,
                                marginBottom: 10,
                                objectFit: 'contain',
                                borderRadius: 25,
                                pointerEvents: 'none',
                                
                            }}
                        />
                        </div>
                        <div onClick={() => {
                           setShowListProduct(true)
                            setdishs(clasicCocktail)
                        }}>
                            <img
                            src={require(langEng ? './assets/clasic.png': './assets/clasices.png')}
                            onContextMenu={(e) => e.preventDefault()}
                            style={{
                                width: 360,
                                height: 120,
                                marginBottom: 10,
                                objectFit: 'contain',
                                borderRadius: 25,
                                pointerEvents: 'none',
                                
                            }}
                        />
                        </div>


                        <div onClick={() => {
                           setShowListProduct(true)
                            setdishs(sangria)
                        }}>
                            <img
                            src={require('./assets/sangria.png')}
                            onContextMenu={(e) => e.preventDefault()}
                            style={{
                                width: 360,
                                height: 120,
                                marginBottom: 10,
                                objectFit: 'contain',
                                borderRadius: 25,
                                pointerEvents: 'none',
                                
                            }}
                        />
                        </div>

                       
                    </div>

                </div>

                {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}
                {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} setShowHappy={setShowHappy} />}
                {showCocktails && <Alcoholic setShowHappy={setShowCocktails} />}
                {showEvents && <EventsScreen setShowHappy={setShowEvents} />}  
                {showColdDrinks && <ColdDrinks setShowHappy={setShowColdDrinks} />}
                {showAlcoholic && <Alcoholic setShowHappy={setShowAlcoholic} />}
                {showBottle && <BottleScreen setShowHappy={setShowBottle} />}
                 {showListProduct && <ListProducts
                    dishs={dishs}
                    setShowListProduct={setShowListProduct}
                />}

            </LayoutContent>
        </div>
    );
}
export default Index;